<div class="pack-page">

  <div class="lx-page-header">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.package_eyebrow' | translate }}</p>
      <h2 class="lx-page-title">{{ packName }}</h2>
    </div>
    <div class="lx-page-actions">
      <button class="lx-btn lx-btn--edit" (click)="getDataForEditModel()"
        data-bs-toggle="modal" data-bs-target="#EditPackage">
        <span class="material-symbols-outlined">edit</span>
        {{ 'btn.edit' | translate }}
      </button>
      <button class="lx-btn lx-btn--danger" data-bs-toggle="modal" data-bs-target="#DeletePackage">
        <span class="material-symbols-outlined">delete</span>
        {{ 'btn.delete' | translate }}
      </button>
    </div>
  </div>

  <div class="pack-overview">
    <div class="pack-img-wrap">
      <img class="pack-img"
        (error)="packImage = 'assets/images/rk.jpeg'"
        [src]="packImage"
        [alt]="packName" />
    </div>
    <div class="pack-stats">
      <div class="pack-stat">
        <span class="material-symbols-outlined">sell</span>
        <div>
          <p class="pack-stat-label">{{ 'lbl.total_price' | translate }}</p>
          <p class="pack-stat-value">{{ totalPrice }} <span class="pack-currency">LE</span></p>
        </div>
      </div>
      <div class="pack-stat">
        <span class="material-symbols-outlined">discount</span>
        <div>
          <p class="pack-stat-label">{{ 'lbl.discount' | translate }}</p>
          <p class="pack-stat-value">{{ pack_discount }} <span class="pack-currency">LE</span></p>
        </div>
      </div>
    </div>
  </div>

  <div class="lx-section-header">
    <span class="material-symbols-outlined">inventory_2</span>
    <h3 class="lx-section-title">{{ 'lbl.products' | translate }}</h3>
  </div>

  <div class="pack-products-grid" *ngIf="showProduct">
    <div class="pack-product-card" *ngFor="let item of product_arr">
      <div class="pack-product-img-wrap">
        <img class="pack-product-img" [src]="item.products.image[0]" [alt]="item.products.name" />
      </div>
      <div class="pack-product-info">
        <p class="pack-product-name">{{ item.products.name }}</p>
        <p class="pack-product-qty">{{ 'pack.qty_prefix' | translate }} {{ item.amount }}</p>
      </div>
    </div>
  </div>

  <div class="lx-empty" *ngIf="!showProduct">
    <div class="lx-empty-icon">
      <span class="material-symbols-outlined">inventory_2</span>
    </div>
    <h3>{{ 'empty.package_products' | translate }}</h3>
    <p>{{ 'empty.package_products_sub' | translate }}</p>
  </div>

</div>

<!-- ══════════════════════════════════════
     Delete Package Modal
════════════════════════════════════════ -->
<div class="modal fade" id="DeletePackage" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="lx-modal-content">
      <div class="lx-modal-header lx-modal-header--centered">
        <div class="lx-modal-icon lx-modal-icon--danger">
          <span class="material-symbols-outlined">delete_forever</span>
        </div>
        <h5 class="lx-modal-title">{{ 'confirm.delete_package' | translate }}</h5>
        <p class="lx-modal-subtitle">
          {{ 'confirm.are_you_sure_delete' | translate }} <strong>{{ packName }}</strong>?
          {{ 'confirm.cannot_undo' | translate }}
        </p>
      </div>
      <div class="lx-modal-footer lx-modal-footer--centered">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button (click)="deletePackage()" type="button" data-bs-dismiss="modal" class="lx-btn lx-btn--danger">
          <span class="material-symbols-outlined">delete</span>
          {{ 'btn.delete' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════
     Edit Package Modal
════════════════════════════════════════ -->
<div class="modal fade" id="EditPackage" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="lx-modal-content">
      <div class="lx-modal-header lx-modal-header--row">
        <div>
          <p class="lx-modal-eyebrow">{{ 'page.package_eyebrow' | translate }}</p>
          <h5 class="lx-modal-title">{{ 'pack.edit' | translate }}</h5>
        </div>
        <button type="button" class="lx-modal-close" data-bs-dismiss="modal">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="lx-modal-body">
        <form [formGroup]="packageForm">
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'lbl.discount' | translate }} (LE)</label>
            <input type="number" class="lx-input" formControlName="discount" [placeholder]="'ph.price' | translate" />
          </div>
        </form>
      </div>
      <div class="lx-modal-footer">
        <button type="button" data-bs-dismiss="modal" class="lx-btn lx-btn--ghost">{{ 'btn.cancel' | translate }}</button>
        <button (click)="save()" type="button" data-bs-dismiss="modal" class="lx-btn lx-btn--primary">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.save_package' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
